export const socialsData = {
    github: 'https://github.com/biswajitchikal847',
    linkedIn: 'https://www.linkedin.com/in/biswajit-biswal-0ba098152/',
    codepen: 'https://codepen.io/bidwajitchikal',
    reddit: 'https://www.reddit.com/user/devbiswajit',
    stackOverflow: 'https://stackoverflow.com/users/18181268/devbiswajit',
}